import React, { createContext, useCallback, useContext, useState } from 'react';
import ReleaseHint from './index';

export const releaseHintContext = createContext();

export const ReleaseHintProvider = ({ children }) => {
  const [releaseHintReferenceDoms, setReleaseHintReferenceDoms] = useState({});

  const addReleaseHintReferenceDom = useCallback((id, element) => {
    setReleaseHintReferenceDoms((states) => ({ ...states, [id]: element }));
  }, []);

  return (
    <releaseHintContext.Provider value={{ releaseHintReferenceDoms, addReleaseHintReferenceDom }}>
      {children}
      <ReleaseHint />
    </releaseHintContext.Provider>
  );
};

export const useReleaseHintReferenceDoms = () =>
  useContext(releaseHintContext).releaseHintReferenceDoms;
